import Vue from 'vue';
import ScrollTo from 'vue-scrollto';

Vue.use(ScrollTo);
